import { styled } from '@mui/material'
import { colorPalette } from '../../../../style/colorPalette'

export const DialogHeader = styled('div')({
  padding: '16px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
})

export const DialogContent = styled('div')({
  flex: 1,
  padding: '16px',
  overflowY: 'auto',
})

export const LoadingContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '40px',
  fontSize: '14px',
  color: colorPalette.monotone[7],
})

export const TableContainer = styled('div')({
  width: '100%',
})

export const TableHeader = styled('div')({
  display: 'flex',
  fontWeight: 600,
  fontSize: '12px',
  padding: '0',
})

export const TableBody = styled('div')({
  display: 'flex',
  flexDirection: 'column',
})

export const TableRow = styled('div')({
  display: 'flex',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: colorPalette.monotone[1],
  },
})

export const HeaderButtons = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
})

export const HeaderCell = styled('div')<{ width: string }>(({ width }) => ({
  width,
  padding: '12px 8px',
  color: colorPalette.monotone[9],
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}))

export const DataCell = styled('div')<{ width: string }>(({ width }) => ({
  width,
  padding: '12px 8px',
  fontSize: '13px',
  color: colorPalette.monotone[9],
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}))

export const DialogTitle = styled('span')({
  fontSize: '14px',
  color: colorPalette.monotone[10],
  fontWeight: 600,
})
